<div class="page-full bg-light">
  <div class="pf-nav d-flex justify-content-between align-items-center bg-white">
    <!-- <div class="item">
        <i class="material-icons ico-back clickable" 
        [hidden]="currentPage !== MerchantSetupSteps.TeamSize"
        (click)="currentPage = MerchantSetupSteps.MerchantType">arrow_back</i>
      </div> -->
    <span class="logo-icon"></span>
    <div class="item text-right">
      <a routerLink="/dashboard" class="text-secondary">{{ isLoggedIn ? 'Ver agenda' : 'Login'}}</a>
    </div>
  </div>

  <div *ngIf="loading" class="py-5">
    <app-loader></app-loader>
  </div>

  <div class="pf-wrapper-2" *ngIf="!loading">
    <div
      *ngIf="paymentInfo?.amountToPayNowCents > 0 && !paymentSuccess"
      class="bg-white rd-3 p-3 text-center text-md-left text-lg-left mb-3"
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-6">
            <!-- <p class="text-bold color-danger mr-3">O pagamento da sua subscrição está em falta.</p> -->
            <p class="color-gray mb-1 mt-2">Valor a pagar</p>
            <h3 class="mb-3 color-black">{{ paymentInfo?.amountToPayNowCents / 100 | currency : 'EUR' }}</h3>
            <!-- <p class="color-gray mb-1">Data limite de pagamento</p>
                        <p class="color-black">13 de Julho 2023</p> -->
          </div>
          <form *ngIf="form" [formGroup]="form" class="col-md-6">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <p class="color-primary text-bold mb-0">Pagar com MBWay</p>
              <i class="ico ico-mbway2 m-0"></i>
            </div>
            <app-text-input
              inputClasses=""
              formControlName="phoneNumber"
              [submitAttempted]="submitAttempted"
              placeholder="{{ 'GENERAL.phone' | translate }}"
              invalidMsg="Número de telemóvel inválido"
            ></app-text-input>

            <p class="text-small color-gray">Irá receber uma notificação na app MBWay para efectuar o pagamento</p>

            <app-alert *ngIf="mbwayError" type="danger" msg="Ocorreu um erro ao processar o pagamento"></app-alert>

            <button [disabled]="saving" [class.disabled]="saving" type="button" class="btn btn-md btn-primary" (click)="processPayment()">
              Pagar agora
            </button>
          </form>
        </div>
      </div>
    </div>

    <div
      *ngIf="(!paymentInfo?.amountToPayNowCents || paymentInfoError) && !paymentSuccess"
      class="bg-white rd-3 p-3 text-center text-md-left text-lg-left mb-3"
    >
      <div class="d-flex flex-column align-items-center">
        <i class="material-icons ico-check color-green mb-2">check_circle</i>
        <h3 class="mb-2">Não tem pagamentos pendentes! 🎉</h3>
        <p class="color-gray">Obrigado por escolher o BUK.</p>
        <button class="btn btn-md btn-primary" routerLink="/dashboard">Ver agenda</button>
      </div>
    </div>

    <div *ngIf="paymentSuccess" class="bg-white rd-3 p-3 text-center text-md-left text-lg-left mb-3">
      <div class="d-flex flex-column align-items-center">
        <i class="material-icons ico-check color-green mb-2">check_circle</i>
        <h3 class="mb-2">Pago com sucesso! 🎉</h3>
        <p class="color-gray">Obrigado por escolher o BUK.</p>
        <button class="btn btn-md btn-primary" routerLink="/dashboard">Ver agenda</button>
      </div>
    </div>

    <div class="bg-white rd-3 p-3 text-center text-md-left text-lg-left mb-3">
      <div class="d-flex flex-column flex-md-row flex-lg-row justify-content-between align-items-center">
        <p class="color-gray mt-2 mb-2">Precisa de ajuda? Fale connosco.</p>
        <button class="btn btn-md btn-secondary" (click)="showHelpModal()">Pedir ajuda</button>
      </div>
    </div>

    <div class="pf-footer d-flex justify-content-center">
      <img class="secure-payments" src="assets/secure-payments-pt.png" alt="" />
    </div>
  </div>
</div>

<div class="row notification full-notification bg-primary" *ngIf="waitingForMbwayPayment">
  <div class="col d-flex flex-column">
    <div class="py-3">
      <app-loader [invert]="true" />
    </div>
    <!-- MBWAY -->
    <ng-container>
      <h3>{{ 'SHARED.paymentModal.waitingMBWayPayment' | translate }}</h3>
      <p>{{ 'SHARED.paymentModal.authorizeMBWayPayment' | translate }}</p>
    </ng-container>
  </div>
</div>
